import React, { useRef } from "react"
import Dropdown from "../Dropdown"
import classNames from "classnames"
import ErrorPopover from "../ErrorPopover/ErrorPopover"
import { getIn } from "formik"
import useIsMount from "../../hooks/useIsMount"
import { useTranslation } from "react-i18next"

// TODO: Handle errors???
export default function FieldDropdown({
  label,
  labelClassname,
  containerClassName,
  field,
  emptyText = "",
  form,
  readOnly = false,
  disabled = undefined,
  onChange = () => {},
  forcedValue = undefined,
  required = false,
  ...props
}) {
  const { t } = useTranslation()
  const input = useRef()
  const isMount = useIsMount()
  const fieldError = getIn(form.errors, field.name)
  const fieldTouched = getIn(form.touched, field.name)
  const showError = fieldError && fieldTouched
  const fieldBlur = () => field.onBlur(field.name)

  return (
    <div className={`d-flex flex-column ${containerClassName}`}>
      {label && (
        <label
          className={classNames(
            "font-weight-semibold mb-3 h3 text-uppercase",
            labelClassname
          )}
        >
          {label} {required && <span className="text-danger">*</span>}
        </label>
      )}
      <Dropdown
        ref={input}
        value={forcedValue ?? field.value}
        onChange={(value) => {
          form.setFieldValue(field.name, value)
          onChange(value)
        }}
        onBlur={fieldBlur}
        disabled={disabled || readOnly}
        invalid={showError}
        {...props}
      />
      {showError && !isMount && (
        <ErrorPopover
          placement={"top-start"}
          target={input.current}
          title={t("field:errors.general")}
          description={fieldError}
        />
      )}
    </div>
  )
}
